import React from 'react'
import { Link } from 'react-router-dom'

const AboutUs = () => {
    return (
        <div style={{minHeight:'100vh'}}>
            <section className="about-section section-padding about-2">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6 col-md-12">
                            <div className="about-img2">
                                <img src="/assets/images/bg/choose.png" alt="" className="img-fluid" />
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-12">
                            <div className="section-heading">
                                <span className="subheading">About US</span>
                                <h4>Monarch Institute offers comprehensive coaching services for medical entrance examinations, NEET.</h4>
                            </div>

                            <p>Monarch Institute is founded by a team of highly qualified, dedicated, and experienced educators committed to fostering academic excellence. Our goal is to create an environment where students can achieve their best through the effective integration of technology and the Indian education system. We strive to offer quality education in a cost-effective manner, allowing students to study at their own convenience</p>

                            <Link to='/contact-us' className="btn btn-main"><i className="fa fa-check mr-2"></i>Learn More</Link>

                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default AboutUs
